import { useContext } from "react"
import { ComparativoUnidadesContext } from "./ComparativoUnidadesContext"

export function useComparativoUnidadesContext() {
    return useContext(ComparativoUnidadesContext)
}
